module.exports = __webpack_public_path__ + "static/media/nextury.39e6a8ee.png";